import React from 'react';
import { ScrollView } from 'react-native';

import { makeStyles } from '@providers/Theme';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '100%',
    backgroundColor: theme.palette.base[100],
  },
}));

export const PublicScreenLayout: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const styles = useStyles();

  return (
    <ScrollView contentInsetAdjustmentBehavior="automatic" style={styles.root}>
      {children}
    </ScrollView>
  );
};
